import { getAsyncActionTypes } from "src/stores/utils";
import apis from "src/apis";

const prefix = "event";

export const GetEventHistories = getAsyncActionTypes(
  prefix,
  "GET_EVENT_HISTORIES"
);

const EventActions = {
  SET_CHECKING_EVENT: `${prefix}/SET_CHECKING_EVENT`,
  HIDE_EVENT: `${prefix}/HIDE_EVENT`,
  SKIP_EVENT: `${prefix}/SKIP_EVENT`,
};

const initialState = {
  checking: null,
  show: false, //start, stop
  bonusType: "mega",
  event: {},
  histories: [],
  point: 0,
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case EventActions.SET_CHECKING_EVENT:
      const { checkingEvent } = action.payload;
      return { ...state, checking: checkingEvent };
    case EventActions.HIDE_EVENT:
      return { ...state, show: false };
    // 이벤트(카드게임) 기능 제외 처리 : 보너스 조회 없이 "이벤트 없음"으로 확정한다.
    case EventActions.SKIP_EVENT:
      return { ...state, checking: false, show: false };
    case GetEventHistories.SUCCESS: {
      const { histories, event } = action.payload;
      return { ...state, histories, event };
    }
    default:
      return state;
  }
};

export function setCheckingEvent(payload) {
  return {
    type: EventActions.SET_CHECKING_EVENT,
    payload,
  };
}

export function hideEvent() {
  return {
    type: EventActions.HIDE_EVENT,
  };
}

// 이벤트(카드게임) 기능 제외 처리로 /event 를 호출하지 않는다.
// 학습 진행 게이트가 checking 의 true -> false 전이로 열리므로,
// 직전의 setCheckingEvent({ checkingEvent: true }) 와 같은 배치에 묶이지 않도록
// 다음 tick 에서 dispatch 한다.
export function checkEvent() {
  return (dispatch) => {
    Promise.resolve().then(() => dispatch({ type: EventActions.SKIP_EVENT }));
  };
}

export function getEventHistories() {
  return {
    type: GetEventHistories,
    request: apis.event.getEventHistories(),
  };
}

export default eventReducer;
